<template>
  <div>
    <lm-input
      ref="inputIncluded"
      class="mb-12"
      label="Include keywords (optional)"
      help="Only show feeds with these keywords"
      :maxlength="0"
      :disabled="disabled"
      @submit="onSubmit"
    />
    <lm-input
      ref="inputExcluded"
      class="mb-12"
      label="Exclude keywords (optional)"
      help="Do not show feeds with these keywords"
      :maxlength="0"
      :disabled="disabled"
      @submit="onSubmit"
    />
    <lm-button class="mb-4" @click="onSubmit">
      Preview
    </lm-button>
  </div>
</template>
<script>
import LmInput from '@/components/form/LmInput'
import LmButton from '@/components/ui/LmButton'

export default {
  name: 'FilteredKeywords',
  components: {LmInput, LmButton},
  props: {
    included: {type: Array, default: () => []},
    excluded: {type: Array, default: () => []},
    disabled: {type: Boolean, default: false}
  },
  mounted() {
    this.setData({
      includedKeywords: this.included,
      excludedKeywords: this.excluded
    })
  },
  methods: {
    onSubmit() {
      this.$emit('preview')
    },
    getData() {
      return {
        included: this.$refs.inputIncluded.data,
        excluded: this.$refs.inputExcluded.data
      }
    },
    setData(filters) {
      const included = filters.includedKeywords || []
      const excluded = filters.excludedKeywords || []
      this.$refs.inputIncluded.setData(included.join(', '))
      this.$refs.inputExcluded.setData(excluded.join(', '))
    }
  }
}
</script>
